var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { Ordering } from '../../../ts/components/Ordering';
export class ClientShow extends Component {
    constructor(isDebugEnabled = false) {
        super('ClientShow', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            new Ordering($('#list-members'), () => {
            });
            const photoCopyrightClauseAcceptedElement = $('#photo_copyright_clause_accepted-muted');
            if (photoCopyrightClauseAcceptedElement.length > 0) {
                if (!photoCopyrightClauseAcceptedElement.get(0).checked) {
                    $('[data-type="image-copyright"] #file-uploader-input-').attr('disabled', 'disabled');
                    $('[data-type="image-copyright"]').addClass('opacity-25');
                }
                photoCopyrightClauseAcceptedElement.on('change', (event) => {
                    if (event.target.checked) {
                        $('[data-type="image-copyright"] #file-uploader-input-').removeAttr('disabled');
                        $('[data-type="image-copyright"]').removeClass('opacity-25');
                    }
                    else {
                        $('[data-type="image-copyright"] #file-uploader-input-').attr('disabled', 'disabled');
                        $('[data-type="image-copyright"]').addClass('opacity-25');
                    }
                });
            }
            this.success();
        });
    }
}
